module.exports = __webpack_public_path__ + "static/media/no-asset.8d6760df.png";